// Trusted-by bar — real company partners Talkani serves.
// Shown just under the hero to establish immediate B2B credibility.
// Each partner name links directly to their case study on /case-studies.
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "../contexts/LangContext";
import { useScrollReveal } from "../hooks/useScrollReveal";

// Real partners — rendered as styled text (not fake logos) to remain accurate.
// `to` targets the anchor for their case study on /case-studies.
const PARTNERS = [
  { name: "LKQ", style: "font-black tracking-tight text-2xl", to: "/case-studies#cs4" },
  { name: "PV Automotive", style: "font-bold italic text-xl", to: "/case-studies#cs4" },
  { name: "TIER", style: "font-black tracking-widest text-2xl", to: "/case-studies#cs5" },
  { name: "Dott", style: "font-black lowercase text-2xl", to: "/case-studies#cs5" },
];

export default function TrustedByBar() {
  const { t } = useLang();
  const [ref, visible] = useScrollReveal();
  const tb = t.trusted_by || {};
  return (
    <section
      ref={ref}
      className={`bg-[#F5F5F5] border-y border-neutral-200 py-8 sr ${visible ? "is-visible" : ""}`}
      data-testid="trusted-by-bar"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex flex-col md:flex-row md:items-center gap-6 md:gap-10">
        <div className="flex-shrink-0">
          <div className="flex items-center gap-2 text-[10px] font-bold tracking-[0.3em] uppercase text-neutral-500">
            <span className="inline-block w-6 h-px bg-[#FF5A00]" />
            {tb.label || "Vertrauen von"}
          </div>
          <p className="text-xs text-neutral-600 mt-1 max-w-xs">
            {tb.subtitle}
          </p>
        </div>
        <div className="flex-1 flex flex-wrap items-center gap-x-8 md:gap-x-12 gap-y-4 md:justify-end">
          {PARTNERS.map((p) => (
            <Link
              key={p.name}
              to={p.to}
              className={`${p.style} text-neutral-800 hover:text-[#FF5A00] transition-colors select-none inline-flex items-center gap-1 group`}
              data-testid={`trusted-partner-${p.name.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {p.name}
              <ArrowUpRight size={14} className="opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
            </Link>
          ))}
          <Link
            to="/case-studies"
            className="text-[10px] font-bold tracking-[0.25em] uppercase text-neutral-500 hover:text-[#FF5A00] hover:border-[#FF5A00] border border-neutral-300 px-3 py-1.5 whitespace-nowrap transition-colors"
            data-testid="trusted-partner-more"
          >
            {tb.and_more || "+ Alle Fallstudien"}
          </Link>
        </div>
      </div>
    </section>
  );
}
